/** Org-level "Powered by Nyafaz" flag for kiosk flows (Face Identity, Salon, Makeup/Hair). */

export const KIOSK_POWERED_BY_STORAGE_KEY = 'naturals_kiosk_powered_by_nyafaz';
export const KIOSK_POWERED_BY_CHANGED_EVENT = 'naturals-kiosk-powered-by-changed';

function emitPoweredByChanged() {
  try {
    window.dispatchEvent(new Event(KIOSK_POWERED_BY_CHANGED_EVENT));
  } catch {
    /* ignore */
  }
}

export function syncKioskPoweredByFlag(enabled) {
  try {
    sessionStorage.setItem(KIOSK_POWERED_BY_STORAGE_KEY, enabled === false ? '0' : '1');
  } catch {
    /* ignore */
  }
  emitPoweredByChanged();
}

export function clearKioskPoweredByFlag() {
  try {
    sessionStorage.removeItem(KIOSK_POWERED_BY_STORAGE_KEY);
  } catch {
    /* ignore */
  }
  emitPoweredByChanged();
}

/** Default true when unknown (login screen, new orgs). */
export function shouldShowKioskPoweredBy() {
  try {
    const stored = sessionStorage.getItem(KIOSK_POWERED_BY_STORAGE_KEY);
    if (stored === '0') return false;
    if (stored === '1') return true;
    return true;
  } catch {
    return true;
  }
}
